/* eslint-disable import/no-cycle */
import gql from 'graphql-tag';
import { actionGQLFields, } from '@tribeplatform/gql-client/graphql';
import { spacePostTypeGQLFields, } from './space-post-type.fields.js';
export function getSpacePostTypeGQLQuery(fields) {
    return gql `
    query GetSpacePostType(
      $spaceId: ID!
      $postTypeId: ID!
    ) {
      spacePostType(
          spaceId: $spaceId
          postTypeId: $postTypeId
    ) {
        ${spacePostTypeGQLFields(fields)}
      }
    }
  `;
}
export function getSpacePostTypesGQLQuery(fields) {
    return gql `
    query GetSpacePostTypes(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $reverse: Boolean
      $spaceId: ID!
    ) {
      spacePostTypes(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        reverse: $reverse
        spaceId: $spaceId
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spacePostTypeGQLFields(fields)}
          }
        }
        nodes {
          ${spacePostTypeGQLFields(fields)}
        }
      }
    }
  `;
}
export const updateSpacePostTypesGQLMutation = (fields) => gql `
  mutation UpdateSpacePostTypes($spaceId: ID!, $input: [UpdateSpacePostTypeInput!]!) {
    updateSpacePostTypes(spaceId: $spaceId, input: $input) {
      ${spacePostTypeGQLFields(fields)}
    }
  }
`;
export const deleteSpacePostTypesGQLMutation = (fields) => gql `
  mutation DeleteSpacePostTypes($spaceId: ID!, $postTypeIds: [ID!]!) {
    deleteSpacePostTypes(spaceId: $spaceId, postTypeIds: $postTypeIds) {
      ${actionGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=space-post-types.gql.js.map